import { ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills } from "../../data";
import "../../../node_modules/devicon/devicon.min.css"
import Skill from "./Skill/Skill";
import MainIntersectProvider from './../../MainIntersectProvider';

export default function Skills() {
    return (
        <section id="skills">
            <div className="container px-5 xl:px-40 pb-15 pt-20 mx-auto">
                <div className="text-center mb-20">
                    <MainIntersectProvider>
                        <ChipIcon className="w-10 inline-block mb-4" />
                    </MainIntersectProvider>
                    <h1 className="sm:text-3xl text-2xl font-medium title-font text-white mb-4">
                        Technical Skills
                    </h1>
                    <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                        A couple of technologies I've been working on lately include.
                    </p>
                </div>
                <div className="space-y-5">
                    {[...Object.entries(skills)].map(([key, value]) => {
                        return (
                            <div key={key + '__01'}>
                                <p className="text-base leading-0">{key}</p>
                                <div className="flex flex-wrap sm:mb-2 -mx-2">
                                    {value.map(({ tech, icon }) => (
                                        <Skill key={tech} tech={tech} icon={icon} />
                                    ))}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}